const Price = [
    2, // 1 level price
    4,
    6,
    8,
    10,
    12
]
export default Price;